import React from 'react'
import { useSelector } from 'react-redux'
import { UserRole } from 'types/user'

import { selectCurrentUser } from 'store/users/users.selectors'

import { Icon, IconType } from 'components/atoms/Icon'
import Button from 'components/molecules/Button'
import InputControl from 'components/molecules/InputControl'
import SelectControl from 'components/molecules/SelectControl'

import { useCreatingInvitation } from './hooks/use-creating-invitation'
import classes from './style.module.css'

interface CreatingInvitationProps {
  accountId?: number
  withoutHeader?: boolean
}

const truncateWithEllipsis = (text: string, maxLength: number = 30): string => {
  if (text.length <= maxLength) {
    return text
  }
  return `${text.slice(0, maxLength)}...`
}

export const InvitationForm: React.FC<CreatingInvitationProps> = ({ accountId, withoutHeader = false }) => {
  const user = useSelector(selectCurrentUser)

  const {
    email,
    isAdmin,
    handleEmailChange,
    handleAdminChange,
    handleSubmit,
    isLoading,
    isValidEmail,
    invalidEmailMessage,
    invitationUrl,
    copyInvitationUrl,
    resetInvitation,
  } = useCreatingInvitation({ accountId })

  return (
    <div className="w-100">
      {!withoutHeader ? (
        <div className="text-center" style={{ padding: '4px' }}>
          Создание приглашения
        </div>
      ) : null}

      {!invitationUrl && (
        <>
          <div className="d-flex">
            <div className="col-lg-6 col-md-6 col-sm-12" style={{ padding: '4px' }}>
              <InputControl
                id="email"
                type="email"
                value={email}
                isValid={isValidEmail}
                invalidMessage={invalidEmailMessage}
                onChangeHandler={handleEmailChange}
                label="Email сотрудника:"
                placeholder="Введите email сотрудника"
              />
            </div>
            {user!.role === UserRole.ADMIN ? (
              <div className="col-lg-6 col-md-6 col-sm-12" style={{ padding: '4px' }}>
                <SelectControl
                  id="isCustomerAdmin"
                  value={isAdmin ? 'customer-admin' : 'customer'}
                  options={[
                    { id: 'customer', name: 'Пользователь' },
                    { id: 'customer-admin', name: 'Администратор' },
                  ]}
                  onChangeHandler={(value) => handleAdminChange(value === 'customer-admin')}
                  label="Роль:"
                />
              </div>
            ) : null}
          </div>
          <div className="d-flex justify-content-end w-100" style={{ padding: '4px' }}>
            <Button isLoading={isLoading} onClick={handleSubmit} content="Пригласить" disabled={!isValidEmail} />
          </div>
        </>
      )}

      {invitationUrl && (
        <div>
          <div className="col-12" style={{ padding: '4px' }}>
            <strong>Ссылка для приглашения:</strong>
            <br />

            <span
              className="d-flex justify-content-between align-items-center form-control"
              style={{ backgroundColor: '#e9ecef', padding: '4px 4px 4px 8px' }}
            >
              <a href={invitationUrl} target="_blank" rel="noopener noreferrer" style={{ padding: '0', margin: '0' }}>
                {truncateWithEllipsis(invitationUrl)}{' '}
              </a>
              <Button
                onClick={(event) => {
                  event.preventDefault()
                  event.stopPropagation()
                  copyInvitationUrl()
                }}
                style={{ marginRight: '-5px' }}
                variant="info"
                className={classes.copyIcon}
              >
                <Icon type={IconType.Copy} width="1rem" height="1rem" />
              </Button>
            </span>
          </div>
          <div>
            <div className="d-flex justify-content-end w-100" style={{ padding: '4px' }}>
              <Button onClick={() => resetInvitation()} content="Закрыть" />
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
